import { viewPost } from '@/services/view-post';
import { sendSentryError } from '@lib/sentry';
import { isBot } from '@/utils';
import { useEffect } from 'react';

const STORAGE_KEY = 'viewed_posts_history';

const checkViewedList = (databaseId: number) => {
  try {
    const viewedPosts = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return { isViewed: viewedPosts[databaseId], viewedPosts };
  } catch (error) {
    console.error('Failed to parse viewed posts from localStorage:', error);
    sendSentryError({
      error,
      source: 'view-post-check-viewed-list',
    });
    return { isViewed: false, viewedPosts: {} };
  }
};

const usePostView = (databaseId?: number) => {
  useEffect(() => {
    if (!databaseId) return;
    if (process.env.NEXT_PUBLIC_PHASE !== 'prod') return;
    if (isBot()) return;

    const { isViewed, viewedPosts } = checkViewedList(databaseId);
    if (isViewed) return;

    const incrementView = async () => {
      await viewPost(databaseId);

      viewedPosts[databaseId] = true;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(viewedPosts));
    };

    incrementView();
  }, [databaseId]);
};

export default usePostView;
